import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const LabelObjectSets = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { LabelObjectSets, defaultState };
